import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { LinkLoginService } from '@link/pages/login/services/link-login.service';
import { SharedLoginSelectors } from '@shared/components/login/store/shared-login.selector-type';

export const linkHomeRedirect: RedirectFunction = () => {
  const store = inject(Store);
  const features = store.selectSignal(SharedLoginSelectors.selectLinkFeatures)();
  const resource = store.selectSignal(SharedLoginSelectors.selectLinkResource)();
  return inject(Router).parseUrl(inject(LinkLoginService).getHomeRoute(features, resource?.resourceId));
};
